module.exports = __webpack_public_path__ + "static/img/7.b006e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/7.png
// module id = A7/4
// module chunks = 0